import { useState } from 'react';
import PropTypes from 'prop-types';
import MetricCard from '../../../MetricCard/MetricCard';
import './DetailedAnalysis.scss';
import whoData from '../../../../Patient/Extras/swimscore_metrics.json'; // <-- your JSON file

const DetailedAnalysis = ({ userData }) => {
  const currentTest = userData.testHistory[userData.testHistory.length - 1];
  const [isOpen, setIsOpen] = useState(true);

  if (!currentTest || !currentTest.categories) return null;

  const categories = currentTest.categories;

  // 🧠 Helper: Find WHO cutoff based on metric name
  const findWhoCutoff = (metricName) => {
    if (!metricName) return null;

    const normalizedName = metricName.toLowerCase().trim();
    const matched = whoData.find((item) => item.metric.toLowerCase().includes(normalizedName));
    return matched ? matched.who_cutoff : null;
  };

  // 🧩 Add WHO cutoff to each metric
  const enhancedCategories = Object.values(categories).map((category) => ({
    ...category,
    metrics: category.metrics.map((metric) => ({
      ...metric,
      who_cutoff: findWhoCutoff(metric.name),
    })),
  }));

  return (
    <div className="detailed-analysis-container dash-card">
      <div className="acc-header" onClick={() => setIsOpen(!isOpen)}>
        <div>
          <p className="acc-title">Count/Concentration</p>
        </div>
        <span className={`chevron ${isOpen ? 'open' : ''}`}>
          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 7L7 0.999999L1 7" stroke="#FCFCFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>

      {isOpen && (
        <div className="metrics-container">
          {enhancedCategories.map((category) =>
            category.metrics.map((metric) => <MetricCard key={`${category.name}-${metric.name}`} metric={metric} categoryName={category.name} />)
          )}
        </div>
      )}
    </div>
  );
};

DetailedAnalysis.propTypes = {
  userData: PropTypes.shape({
    name: PropTypes.string,
    testHistory: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        overallScore: PropTypes.number,
        categories: PropTypes.object,
      })
    ),
  }).isRequired,
};

export default DetailedAnalysis;
